import React, { useEffect, useMemo, useRef, useState, useImperativeHandle } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { TABLE_DATA, ClearableInput } from "util";

import update from "immutability-helper";

import Rows from "./DnDTables/DataTable";

import ModalPortal from "util/component/Modal";
import { Confirm } from "util/component/Modal/Modal";

import { useTranslation } from "react-i18next";

import { EditableDiv } from "util/component/Input";

// import AsyncSelect from "util/component/SearchableSelect/async";

// import SelectMultiV2 from "util/component/SearchableSelect/asyncMultiv2";

import AsyncSelectMulti from "util/component/SearchableSelect/asyncMultiv3";
import CustomTextAreaList from "./DnDTables/CustomTextAreaList";

const P_TYPE = "qc";
const API = "";

const HeaderTarget = {
    qcReceivingSite: "Receiving Site",
    qcSendingSite: "Sending Site",
    qcAlertLimit: "Alert Limit",
    qcActionLimit: "Action Limit",
    qcAcceptanceLimit: "Acceptance Limit",
};

const TRIANGLE_RED = "rgb(248 79 49)";
const TRIANGLE_GREEN = "rgb(35 197 82)";
const TRIANGLE_GRAY = "rgb(235 230 230)";

const initialData = TABLE_DATA[P_TYPE]

const QCTable = (props, _ref) => {
    const { t } = useTranslation(["page"]);
    const { so, sso, PROCode, setso, onOpen, RevCmptCheckList, remarkList, updateRemarkList } = props;

    const [Hide, setHide] = useState(false);
    const [ModalOpen, SetModalOpen] = useState(false);
    const [remarkOpen, SetRemarkOpen] = useState(false);
    const [textValue, setTextValue] = useState();
    const [TData, setTData] = useState([]);
    const modalData = useRef({ modalType: null });
    const [Header, SetHeader] = useState(HeaderTarget);
    const [QCGroup, SetQCGroup] = useState([]);

    const [NewQCGroup, SetNewQCGroup] = useState("");

    useImperativeHandle(_ref, () => ({

        getTableData: () => {
            return TData;
        },
        getHeaderData: () => {
            return Header;
        },
        initial: () => {
            setTData((TD) => []);
        },
        add: () => {
            setTData((TP) =>
                update(TP, {
                    $push: [[]],
                })
            );
        },
        move: ({ dragIndex, hoverIndex }) => {
            setTData((TP) =>
                update(TP, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, TP[dragIndex]],
                    ],
                })
            );
        },
        remove: (idx) => {
            setTData((TP) =>
                update(TP, {
                    $splice: [[idx, 1]],
                })
            );
        },
        loadData: ({ data, header }) => {
            let newVal = [];
            let tmparr;
            let tmp;
            let fidx;
            const qcGroups = [];
            data.forEach((d) => {
                tmparr = [];
                d.forEach((dd) => {
                    tmp = TABLE_DATA[P_TYPE];
                    Object.keys(dd).forEach((k) => {
                        fidx = tmp.findIndex((i) => i.name === k);
                        if (fidx > -1)
                            tmp = update(tmp, {
                                [fidx]: { $merge: { value: dd[k] } },
                            });
                        if (k === "samplePoint") {
                            tmp = update(tmp, {
                                [fidx]: {
                                    $merge: { label: dd["samplePointNm"] },
                                },
                            });
                        } else if (k === "optionCd") {
                            tmp = update(tmp, {
                                [fidx]: {
                                    $merge: { label: dd["optionNm"] },
                                },
                            });
                        } else if (k === "sampleDesc") {
                            if (dd.sampleDesc && !qcGroups.find((f) => f.value === dd.sampleDesc)) {
                                qcGroups.push({value:dd.sampleDesc ,uniqueCode :[dd.uniqueCode]});
                            }else {
                                qcGroups.forEach((data,i) => {
                                    if(data.value === d.value){
                                        data.uniqueCode.push(d.uniqueCode);
                                    }

                                })
                            }
                        } else if (k === "unit" && dd?.unitType?.toString() === "1") {
                            tmp = update(tmp, {
                                [fidx]: { $merge: { type: "text" } },
                            });
                        } else if (k === "rcvCritical") {
                            tmp = update(tmp, {
                                [fidx]: {
                                    $merge: { label: dd["rcvCriticalNm"] },
                                },
                            });
                        }

                    });

                    tmparr = [...tmparr, ...[tmp]];
                });

                newVal = [...newVal, [...tmparr]];
            });
            //SetQCGroup(Array.from(new Set(qcGroups)));
            setTData((d) => [...newVal]);
            SetHeader((d) => {
                let newData = {};
                Object.keys(HeaderTarget).forEach((i) => {
                    newData[i] = !!header?.[i] ? header?.[i] : HeaderTarget?.[i];
                });
                return newData;
            });
        },
        copy: (data) => {
            const findIdx = so.findIndex((i) => i.tempUniqCode === data.tempUniqCode);
            const target = JSON.parse(JSON.stringify(TData[findIdx]));
            target.forEach((e) => {
                const a = e.map((ee) => {
                    if (ee.name === "uniqueCode") ee.value = "";
                });
            });

            setTData((d) =>
                update(d, {
                    $push: [target],
                })
            );
        },
        reset:(idx)=>{
            setTData((TP) =>
                update(TP, {
                    $splice: [[idx, 1],[idx, 0, []]],
                })
            );

        }
    }));

    const updateRemarkListRow = (idx,data,type)  => {
        updateRemarkList(idx,data,type);
    };

    const onOpenWrapper = (vv, uniqueCode) => {
        onOpen(vv, uniqueCode, TData, "QC");
    };
    const HandleHide = () => {
        setHide(!Hide);
    };

    const addRow = (tempUniqCode) => {
        const findIdx = so.findIndex((e) => e.tempUniqCode === tempUniqCode);
        setTData((TP) =>
            update(TP, {
                [findIdx]: { $push: [initialData] },
            })
        );
    };

    const changeRow = (code, idx, idx2, obj) => {
        let findIdx = so.findIndex((e) => e.tempUniqCode === code);

        if (obj.check === "hide") {
            if (obj.value === "") {
                obj.value = "TRUE";
            }
        }
        let setData = {
            [idx2]: { $merge: { ...obj } },
        };

        if (!!obj.other) {
            const pcodeIdx = TData[findIdx][idx].findIndex((e) => e.name === "paraCd");
            if (pcodeIdx > -1) {
                setData = {
                    ...setData,
                    [pcodeIdx]: { $merge: { value: obj.other.paraCd } },
                };
            }
            const unitIdx = TData[findIdx][idx].findIndex((e) => e.name === "unit");
            if (obj.other?.unitType?.toString() === "1") {
                setData = {
                    ...setData,
                    [unitIdx]: { $merge: { type: "text", value: "" } },
                };
            // } else if (!!obj.other?.unitType?.toString()) {
            //     const defaultUnitType = initialData.find((e) => e.name === "unit");
            //     setData = {
            //         ...setData,
            //         [unitIdx]: {
            //             $merge: {
            //                 type: defaultUnitType.type,
            //                 value: obj.other?.unit,
            //             },
            //         },
            //     };
            }
        }
        /*
            URL 요청
            day/cycle이 code !== "D" 일 경우, dayCycle을 ZZ로 고정 및 readOnly
        */
        if (!!obj.sample) {
            const dayIdx = TData[findIdx][idx].findIndex((e) => e.name === "dayCycle");
            const valchk = TData[findIdx][idx][dayIdx]["value"];
            if (obj.value !== "D") {
                setData = {
                    ...setData,
                    [dayIdx]: { $merge: { readOnly: true, value: "ZZ" } },
                };
            } else {
                setData = {
                    ...setData,
                    [dayIdx]: {
                        $merge: {
                            readOnly: false,
                            value: valchk === "ZZ" ? "" : valchk.toString(),
                        },
                    },
                };
            }
        }

        setTData((TP) =>
            update(TP, {
                [findIdx]: {
                    [idx]: setData,
                },
            })
        );
    };

    const changeRemark = (uniqueCode,value,name,oldValue) => {

        TData.forEach((soData, i) => {
            soData.forEach((row, ii) =>{
                row.forEach((data,iii)=>{
                    if(data.name === 'uniqueCode'  &&uniqueCode.findIndex((d) => d && d === data.value) !== -1){
                        let setData = {
                            [row.findIndex((d) => d.name ===name)]: { $merge: { ...value } },
                        };
                        setTData((TP) =>
                            update(TP, {
                                [i]: {
                                    [ii]: setData,
                                },
                            })
                        );
                    }else if(data.name === name  && uniqueCode.findIndex((d) => (d === undefined || d === '')) !== -1  && data.value === oldValue){
                        let setData = {
                            [iii]: { $merge: { ...value } },
                        };
                        setTData((TP) =>
                            update(TP, {
                                [i]: {
                                    [ii]: setData,
                                },
                            })
                        );
                    }
                })
            })
        })
        so.forEach((data,i) =>{

            if( uniqueCode.findIndex((d) => d && d === data.uniqueCode) !== -1) {
                setso({
                    type: P_TYPE,
                    data: value.value,
                    idx: i,
                })
            }else if( uniqueCode.findIndex((d) => d) === -1  && data.qcRemark === oldValue){
                setso({
                    type: P_TYPE,
                    data: value.value,
                    idx: i,
                })
            }

        })

    }
    const changeAllQCGroup = (uniqueCode,value,name) => {

        TData.forEach((soData, i) => {
            soData.forEach((row, ii) => {
                row.forEach((data, iii) => {
                    if (data.name === 'uniqueCode' && uniqueCode && uniqueCode.findIndex((d) => d === data.value) !== -1) {
                        let setData = {
                            [row.findIndex((d) => d.name === name)]: {$merge: {...value}},
                        };
                        setTData((TP) =>
                            update(TP, {
                                [i]: {
                                    [ii]: setData,
                                },
                            })
                        );
                    }else if(!uniqueCode){

                    }
                })
            })
        })
    }


    const moveRow = (code, dragIndex, hoverIndex) => {
        const findIdx = so.findIndex((e) => e.tempUniqCode === code);
        setTData((TP) =>
            update(TP, {
                [findIdx]: {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, TP[findIdx][dragIndex]],
                    ],
                },
            })
        );
    };

    const modalRender = () => {
        return (
            <Confirm onClose={() => SetModalOpen(false)} onConfirm={() => deleteRowConfirm()}>
                <p>{t("delete")}</p>
            </Confirm>
        );
    };
    const modal = useMemo(modalRender, [ModalOpen]);

    const deleteRow = (code, index) => {
        modalData.current = { code, index };
        SetModalOpen(true);
    };
    const deleteRowConfirm = () => {
        const { code, index } = modalData.current;

        const findIdx = so.findIndex((e) => e.tempUniqCode === code);
        setTData((TP) =>
            update(TP, {
                [findIdx]: {
                    $splice: [[index, 1]],
                },
            })
        );
        SetModalOpen(false);
    };

    const copyRow = (code, index) => {
        const findIdx = so.findIndex((e) => e.tempUniqCode === code);

        // 파라미터 copy시 원본 데이터도 같이 "" 값이 들어가는 현상 수정
        const newArr = JSON.parse(JSON.stringify(TData[findIdx][index]));
        newArr.forEach((f) => {
            if (f.name === "uniqueCode") {
                f.value = "";
            }
            if (f.name === "interfaceCode") {
                f.value = "";
            }
        });
        setTData((TP) =>
            update(TP, {
                [findIdx]: { $push: [newArr] },
            })
        );
    };

    // urs 30 : Receving Data -> Sending Data 카피 기능
    const copyRev = (code, index) => {
        const findIdx = so.findIndex((e) => e.tempUniqCode === code);

        // [fidx]: { $merge: { value: dd[k] } }
        // dataTable 참조,
        let rcvStartIndex = 0;
        let merge = {};
        TData[findIdx][index].forEach(({ name }, i) => {
            if (name.match(/^rcv/) && name !== "rcvCopy" && name !== "rcvCritical" && rcvStartIndex < 1) {
                rcvStartIndex = i;
            }

            if (name.match(/^snd/) && name !== "sndCritical" ) {
                merge = { ...merge, [i]: { $merge: { value: TData[findIdx][index][rcvStartIndex]?.value } } };
                rcvStartIndex++;
            }
        });
        setTData((TP) =>
            update(TP, {
                [findIdx]: {
                    [index]: merge,
                },
            })
        );
    };

    const copySndToRcv = (code, index) => {
        const findIdx = so.findIndex((e) => e.tempUniqCode === code);
        // [fidx]: { $merge: { value: dd[k] } }
        // dataTable 참조,
        let sndStartIndex = TData[findIdx][index].length;
        let merge = {};

        for (let i = TData[findIdx][index].length-1; i >= 0  ; i-- ){
            if (TData[findIdx][index][i].name.match(/^snd/) && sndStartIndex === TData[findIdx][index].length) {
                sndStartIndex = i;
            }
            if (TData[findIdx][index][i].name.match(/^rcv/) && TData[findIdx][index][i].name !== "rcvCopy" && TData[findIdx][index][i].name !== "rcvCritical") {
                merge = { ...merge, [i]: { $merge: { value: TData[findIdx][index][sndStartIndex]?.value } } };
                sndStartIndex--;
            }
        }

        setTData((TP) =>
            update(TP, {
                [findIdx]: {
                    [index]: merge,
                },
            })
        );
    };

    const [ soIndex, setSoIndex] = useState(0);

    // urs 30 끝
    const remarkState = (e) => {
        SetRemarkOpen(!remarkOpen);

    };
    const addClass = (e) =>{
        e.target.closest('td').classList.add('tdFocused');
    }
    const removeClass = (className) =>{
        document.querySelectorAll('.'+className).forEach(e =>{
            e.classList.remove(className)
        })
    }

    const renderFunc = () => {
        try {
            let _sso = so[sso];

            if (!!_sso.tempUniqCode) {
                let remark = _sso[P_TYPE + "Remark"];
                const reviewData = RevCmptCheckList.find(
                    (f) => f.uniqueCode === _sso.uniqueCode && f.celNm === P_TYPE + "Remark"
                );
                let bg = TRIANGLE_GRAY;
                if (reviewData?.cmptType) {
                    if (reviewData.cmptType === "R") bg = TRIANGLE_RED;
                    else bg = TRIANGLE_GREEN;
                }
                return (
                    <React.Fragment>
                        <tr>
                            <td colSpan={Object.keys(initialData.filter(f => f.type !== "hidden")).length} className="name">
                                <div className={"namename"}>
                                    {_sso?.desc}
                                    {/* <div className={"code"}>{"(" + _sso?.seqCode + ")"}</div> */}
                                </div>
                            </td>
                            <td>
                                <input
                                    type="checkbox"
                                    name={remark}
                                    checked={remark !== "FALSE"}
                                    onChange={(e) => {
                                        setso({
                                            type: P_TYPE,
                                            data: e.target.checked ? "" : "FALSE",
                                            idx: sso,
                                        });
                                    }}
                                />
                            </td>
                        </tr>
                        {remark !== "FALSE" && (
                            <tr>
                                <td
                                    colSpan={Object.keys(initialData.filter(f => f.type !== "hidden")).length + 1}
                                    className="soremark"
                                    style={{ position: "relative" }}
                                >
                                    {_sso.uniqueCode && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    zIndex: 10,
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    backgroundColor: bg,
                                                    top: 0,
                                                    right: 0,
                                                    width: 20,
                                                    height: 20,
                                                    transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                                }}
                                                onClick={() =>
                                                    onOpen(
                                                        {
                                                            name: P_TYPE + "Remark",
                                                        },
                                                        _sso?.uniqueCode
                                                    )
                                                }
                                            ></div>
                                        </div>
                                    )}

                                    <div
                                        onClick={(e)=>{remarkState(e);addClass(e);}}
                                        contentEditable={"inherit"}
                                        suppressContentEditableWarning={true}
                                        style={{ position: "relative",minHeight:"70%" }}
                                        onBlur={(e) => {
                                            setso({
                                                type: P_TYPE,
                                                data: e.target.innerText,
                                                idx: sso,
                                            });
                                        }}
                                    >
                                        {remark}
                                    </div>
                                    {remarkOpen &&
                                        <CustomTextAreaList
                                            key={"remarkQc" + _sso}
                                            data={remark}
                                            changed={(e) => {
                                                setso({
                                                    type: P_TYPE,
                                                    data: e.target.innerText,
                                                    idx: sso,
                                                });
                                                updateRemarkListRow(_sso.uniqueCode, e.target.innerText.toString().trim(), "qc");
                                            }}
                                            optionChanged={(value) => {
                                                setso({
                                                    type: P_TYPE,
                                                    data: value,
                                                    idx: sso,
                                                });
                                                updateRemarkListRow(_sso.uniqueCode, value, "qc");
                                            }}
                                            changeData={
                                                (uniqueCode, value,oldValue) => {
                                                    changeRemark(uniqueCode, value, "remark",oldValue);
                                                    //updateRemarkListRow(uniqueCode,value.value,tableType);
                                                }}
                                            dataList={newRemarkList}
                                            updateListRow={updateRemarkListRow}
                                            setDataList={setNewRemarkList}
                                            openState={() =>{remarkState();removeClass('tdFocused');}}
                                            textValue={textValue}
                                            setTextValue={setTextValue}
                                        />
                                    }
                                </td>
                            </tr>
                        )}
                        {TData[sso].map((v, ii) => {
                            return (
                                <Rows
                                    api={API}
                                    code={_sso.tempUniqCode}
                                    PROCode={PROCode}
                                    index={ii}
                                    rowData={v}
                                    copied={copyRow}
                                    moveRow={moveRow}
                                    changed={changeRow}
                                    deleted={deleteRow}
                                    key={"qc" + ii}
                                    copyRev={copyRev}
                                    copySndToRcv={copySndToRcv}
                                    onOpen={onOpenWrapper}
                                    RevCmptCheckList={RevCmptCheckList}
                                    qcGroup={QCGroup}
                                    tableType={"qc"}
                                    remarkList={newRemarkList}
                                    setRemarkList = {setNewRemarkList}
                                    SetQCGroup={SetQCGroup}
                                    changeRemark = {changeRemark}
                                    updateRemarkListRow={updateRemarkListRow}
                                    FindQCGroup = {FindQCGroup}
                                    removeClass = {removeClass}
                                />
                            );
                        })}
                        <tr className="add_param" onClick={() => addRow(_sso.tempUniqCode)}>
                            <td colSpan={Object.keys(initialData.filter(f => f.type !== "hidden")).length +1 }>+Add Parameter</td>
                        </tr>
                    </React.Fragment>
                );
            } else {
                const ret = so.map((k, i) => {
                    if (!!!k.code) {
                        return null;
                    }
                    try {
                        let chk = TData[i].filter((v) => {
                            let chk2 = v.find((c) => c.name === "hide");
                            return chk2.value !== "TRUE";
                        });
                        let remark = k[P_TYPE + "Remark"];
                        const reviewData = RevCmptCheckList.find(
                            (f) => f.uniqueCode === k.uniqueCode && f.celNm === P_TYPE + "Remark"
                        );
                        let bg = TRIANGLE_GRAY;
                        if (reviewData?.cmptType) {
                            if (reviewData.cmptType === "R") bg = TRIANGLE_RED;
                            else bg = TRIANGLE_GREEN;
                        }

                        return (
                            <React.Fragment key={i}>
                                <tr>
                                    <td colSpan={Object.keys(initialData.filter(f => f.type !== "hidden")).length} className="name">
                                        <div className={"namename"}>
                                            {i + 1 + "." + k.desc}
                                            {/* <div className={"code"}>
                                                    {"(" + k.seqCode + ")"}
                                                </div> */}
                                        </div>
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            name={remark}
                                            checked={remark !== "FALSE"}
                                            onChange={(e) => {
                                                setso({
                                                    type: P_TYPE,
                                                    data: e.target.checked ? "" : "FALSE",
                                                    idx: i,
                                                });
                                            }}
                                        />
                                    </td>
                                    {/*<td></td>*/}
                                </tr>
                                {remark !== "FALSE" && (
                                    <tr>
                                        <td
                                            colSpan={Object.keys(initialData.filter(f => f.type !== "hidden")).length +1}
                                            className="soremark"
                                            style={{ position: "relative" }}
                                        >
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    overflow: "hidden",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        zIndex: 10,
                                                        cursor: "pointer",
                                                        position: "absolute",
                                                        backgroundColor: bg,
                                                        top: 0,
                                                        right: 0,
                                                        width: 20,
                                                        height: 20,
                                                        transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                                    }}
                                                    onClick={() =>
                                                        onOpen(
                                                            {
                                                                name: P_TYPE + "Remark",
                                                            },
                                                            k.uniqueCode
                                                        )
                                                    }
                                                ></div>
                                            </div>
                                            <div
                                                onClick={(e)=>{remarkState(e); setSoIndex(i);addClass(e);}}
                                                contentEditable={"inherit"}
                                                suppressContentEditableWarning={true}
                                                onBlur={(e) => {
                                                    setso({
                                                        type: P_TYPE,
                                                        data: e.target.innerText,
                                                        idx: i,
                                                    });
                                                }}
                                                style={{
                                                    position: "relative",minHeight:"70%"
                                                }}
                                            >
                                                {remark}
                                            </div>
                                            {remarkOpen &&
                                                <CustomTextAreaList
                                                    key={"remarkQc" + _sso}
                                                    data={remark}
                                                    changed={(e) => {
                                                        setso({
                                                            type: P_TYPE,
                                                            data: e.target.innerText,
                                                            idx: soIndex,
                                                        });
                                                        updateRemarkListRow(_sso.uniqueCode, e.target.innerText.toString().trim(), "qc");
                                                    }}
                                                    optionChanged={(value) => {
                                                        setso({
                                                            type: P_TYPE,
                                                            data: value,
                                                            idx: soIndex,
                                                        });
                                                        updateRemarkListRow(_sso.uniqueCode, value, "qc");
                                                    }}
                                                    changeData={
                                                        (uniqueCode, value,oldValue) => {
                                                            changeRemark(uniqueCode, value, soIndex,oldValue);
                                                            //updateRemarkListRow(uniqueCode,value.value,tableType);
                                                        }}
                                                    dataList={newRemarkList}
                                                    updateListRow={updateRemarkListRow}
                                                    setDataList={setNewRemarkList}
                                                    SetQCGroup={SetQCGroup}
                                                    openState={() =>{remarkState();removeClass('tdFocused');}}
                                                    textValue={textValue}
                                                    setTextValue={setTextValue}
                                                />
                                            }
                                        </td>
                                    </tr>
                                )}
                                {TData[i].map((v, ii) => {
                                    return (
                                        <Rows
                                            api={API}
                                            code={k.tempUniqCode}
                                            PROCode={PROCode}
                                            index={ii}
                                            rowData={v}
                                            copied={copyRow}
                                            moveRow={moveRow}
                                            changed={changeRow}
                                            deleted={deleteRow}
                                            key={"qc" + ii}
                                            tableType={"qc"}
                                            copyRev={copyRev}
                                            copySndToRcv={copySndToRcv}
                                            onOpen={onOpenWrapper}
                                            RevCmptCheckList={RevCmptCheckList}
                                            qcGroup={QCGroup}
                                            remarkList={newRemarkList}
                                            setRemarkList = {setNewRemarkList}
                                            changeRemark = {changeRemark}
                                            updateRemarkListRow={updateRemarkListRow}
                                            SetQCGroup={SetQCGroup}
                                            FindQCGroup = {FindQCGroup}
                                            removeClass = {removeClass}
                                        />
                                    );
                                })}
                            </React.Fragment>
                        );
                    } catch (e) {
                        return null;
                    }
                });
                return ret;
            }
        } catch (e) {
            return null;
        }
    };

    const headerChange = (d, v) => {
        SetHeader((header) => ({
            ...header,
            [d.name]: v,
        }));
    };

    const [newRemarkList,setNewRemarkList] = useState({});
    useEffect(() => {
        //const t = newRemarkList?.filter(item => item.remark.includes(e.target.innerText.toString().trim()) );
        const tableRemarkList=remarkList.filter(item => item.name === "qc");
        //const sortRemarkList=[...new Set(tableRemarkList.map( x =>x.remark))];
        let remarkData = [];
        tableRemarkList.sort().forEach((d,i) => {

            if (remarkData.findIndex((newData) => newData.value === d.value) === -1) {
                remarkData.push({value:d.value,oldValue:d.value,uniqueCode :[d.uniqueCode]});
            }else if(remarkData.findIndex((newData) => newData.value === d.value && newData.uniqueCode !== d.uniqueCode) !== -1){
                // remarkData = [remarkData,]
                remarkData.forEach((data,i) => {
                    if(data.value === d.value){
                        data.uniqueCode.push(d.uniqueCode);
                    }

                })
            }



        });
        so.forEach((d,i) => {
            if (remarkData.findIndex((newData) => newData.value === d.qcRemark ) === -1 && d.qcRemark !== "FALSE" && d.qcRemark ) {

                remarkData.push({value:d.qcRemark,oldValue:d.qcRemark,uniqueCode :[d.uniqueCode]});
            }else if(remarkData.findIndex((newData) => newData.value === d.qcRemark && newData.uniqueCode !== d.uniqueCode ) !== -1 && d.qcRemark !== "FALSE" && d.qcRemark ){
                remarkData.forEach((data,i) => {
                    if(data.value === d.qcRemark){
                        data.uniqueCode.push(d.uniqueCode);
                    }

                })
            }
        });
        setNewRemarkList(remarkData);
    }, [remarkList]);

    useEffect(() => {
        FindQCGroup();
    }, [TData]);

    const FindQCGroup = ()=>{
        let qcDataGroup = [];
        TData?.forEach((d,i) =>{
            d.forEach((dd,ii)=>{
                let uniqueCode="";
                let smpDescValue = ""
                dd.forEach((rowData,z) =>{
                    if (rowData.name === "sampleDesc" ) {
                        smpDescValue = rowData.value

                    }else if(rowData.name === "uniqueCode"){
                        uniqueCode = rowData.value
                    }

                })
                if (qcDataGroup.find((newData) => newData.value === smpDescValue)) {
                    qcDataGroup.forEach((qcData,i) => {
                        if(qcData.value === smpDescValue && qcData.value){
                            qcData.uniqueCode.push(uniqueCode);
                        }
                    })
                }else if(smpDescValue){
                    qcDataGroup.push({value:smpDescValue,uniqueCode :[uniqueCode],oldValue:smpDescValue});
                }

            })
        });
        SetQCGroup(qcDataGroup);
    }

    const HandleSetNewQCGroup = (element) => {
        SetNewQCGroup(element.target.value);
    };

    const HandleNewQCgroupAdd = () => {
        if (!NewQCGroup) return;
        if (QCGroup.find((f) => f.value === NewQCGroup)) {
            HandleSetNewQCGroup({ target: "" });
            return;
        }
        SetQCGroup((OLD) =>
            update(OLD, {
                $push: [{ value: NewQCGroup, label: NewQCGroup }],
            })
        );
    };

    const HandleDeleteQCGroup = (index) => {
        const v = [...QCGroup][index].value;
        const find = [...TData].map((e, i) => {
            return e?.map((ee, ii) => {
                const sd = ee.findIndex((f) => f.name === "sampleDesc");
                if (ee[sd]?.value === v) {
                    return update(ee, {
                        [sd]: { $merge: { value: "" } },
                    });
                } else {
                    return ee;
                }
            });
        });
        setTData(find);
        SetQCGroup((OLD) =>
            update(OLD, {
                $splice: [[index, 1]],
            })
        );
    };

    const HandleModifyQCGroup = (value, index) => {
        console.log("value  > " , value);
        if (!value) return;
        const v = [...QCGroup][index].value;
        const find = [...TData].map((e, i) => {
            return e?.map((ee, ii) => {
                const sd = ee.findIndex((f) => f.name === "sampleDesc");
                if (ee[sd]?.value === v) {
                    return update(ee, {
                        [sd]: { $merge: { value: value } },
                    });
                } else {
                    return ee;
                }
            });
        });

        SetQCGroup((OLD) =>
            update(OLD, {
                [index]: { $set: { value: value, label: value } },
            })
        );
        setTData(find);
    };

    return (
        <section className="create" style={{ width: "initial" }}>
            <div className={"in_table tbl_box " + (Hide ? "hide" : "")}>
                <h1 className={"title "} onClick={HandleHide}>
                Performance Parameter-QC <FontAwesomeIcon icon={faAngleUp} />
                </h1>
                <div className={"data_table "}>
{/*                    <div className={"d-flex gap-10 mb-1"}>
                        <div style={{ flex: "0 0 200px" }}>
                            <ClearableInput clear={SetNewQCGroup}>
                                <input
                                    type={"text"}
                                    style={{ padding: "3px" }}
                                    onChange={HandleSetNewQCGroup}
                                    value={NewQCGroup || ""}
                                />
                            </ClearableInput>
                        </div>
                        <div>
                            <button className={"bpl-btn small"} onClick={HandleNewQCgroupAdd}>
                                Add
                            </button>
                        </div>
                    </div>
                    <div className={"d-flex gap-5 mb-1 wrap qc-group-box"}>
                        {QCGroup?.map((e, index) => {
                            return (
                                <div key={"qcGroup" + index}>
                                    <input
                                        type={"text"}
                                        value={e.value}
                                        onChange={(element) => HandleModifyQCGroup(element.target.value, index)}
                                    />
                                    <button onClick={() => HandleDeleteQCGroup(index)}>X</button>
                                </div>
                            );
                        })}
                    </div>*/}

                    <DndProvider backend={HTML5Backend}>
                        <table style={{ tableLayout: "initial", width: "max-content", minWidth: "100%" }}>
                            <colgroup>
                                <col width="25" />
                                {/* para code */}
                                {/* <col width="60" /> */}
                                {/* sample point */}
                                {/*<col width="100" />*/}
                                {/* day cycle */}
                                {/*<col width="50" />*/}
                                {/* Sample Description */}
                                <col width="90" />
                                {/* paramter */}
                                <col width="90" />

                                {/* test method */}
                                <col width="70" />
                                {/* unit */}
                                <col width="60" />
                                {/* rcv critical */}
                                <col width="70" />
                                {/* rcv alert */}
                                <col width="25" />
                                <col width="35" />
                                <col width="25" />
                                <col width="35" />
                                {/* rcv action */}
                                <col width="25" />
                                <col width="35" />
                                <col width="25" />
                                <col width="35" />
                                {/* rcv acc */}
                                <col width="25" />
                                <col width="35" />
                                <col width="25" />
                                <col width="35" />
                                {/* Copy */}
                                <col width="20" />
                                {/* snd critical */}
                                <col width="70" />
                                {/* snd alert */}
                                <col width="25" />
                                <col width="35" />
                                <col width="25" />
                                <col width="35" />
                                {/* snd action */}
                                <col width="25" />
                                <col width="35" />
                                <col width="25" />
                                <col width="35" />
                                {/* snd acc */}
                                <col width="25" />
                                <col width="35" />
                                <col width="25" />
                                <col width="35" />
                                {/* Options */}
                                <col width="80" />
                                {/* Reference */}
                                <col width="90" />
                                <col width="30" />
                                {/*<col width="30" />*/}
                                <col width="20" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th rowSpan="3"></th>
                                    {/* <th rowSpan="3">Parameter Code</th> */}
{/*                                    <th rowSpan="3">Sample Point</th>
                                    <th rowSpan="3">Day / Cycle</th>*/}
                                    <th rowSpan="3">Sample Description</th>
                                    <th rowSpan="3">Test Item</th>

                                    <th rowSpan="3">Method No.</th>
                                    <th rowSpan="3">Unit</th>
                                    <th colSpan="13">
                                        <EditableDiv
                                            change={headerChange}
                                            data={{
                                                name: "qcReceivingSite",
                                                value: Header?.qcReceivingSite || "",
                                            }}
                                        />
                                    </th>
                                    <th rowSpan="3"></th>
                                    <th colSpan="13">
                                        <EditableDiv
                                            change={headerChange}
                                            data={{
                                                name: "qcSendingSite",
                                                value: Header?.qcSendingSite || "",
                                            }}
                                        />
                                    </th>
                                    <th rowSpan="3">Options</th>
                                    <th rowSpan="3">Reference</th>

                                    <th rowSpan="3">Remark</th>
                                    {/*<th rowSpan="3">Hide</th>*/}
                                </tr>

                                <tr>
                                    <th colSpan="1" rowSpan="2">
                                        Criticality
                                    </th>
                                    <th colSpan="4">Alert Limit</th>
                                    <th colSpan="4">Action Limit</th>
                                    <th colSpan="4">Acceptance Limit</th>
                                    <th colSpan="1" rowSpan="2">
                                        Criticality
                                    </th>
                                    <th colSpan="4">
                                        <EditableDiv
                                            change={headerChange}
                                            data={{
                                                name: "qcAlertLimit",
                                                value: Header?.qcAlertLimit || "",
                                            }}
                                        />
                                    </th>
                                    <th colSpan="4">
                                        <EditableDiv
                                            change={headerChange}
                                            data={{
                                                name: "qcActionLimit",
                                                value: Header?.qcActionLimit || "",
                                            }}
                                        />
                                    </th>
                                    <th colSpan="4">
                                        <EditableDiv
                                            change={headerChange}
                                            data={{
                                                name: "qcAcceptanceLimit",
                                                value: Header?.qcAcceptanceLimit || "",
                                            }}
                                        />
                                    </th>
                                </tr>

                                <tr>
                                    <th colSpan="2">Min</th>
                                    <th colSpan="2">Max</th>
                                    <th colSpan="2">Min</th>
                                    <th colSpan="2">Max</th>
                                    <th colSpan="2">Min</th>
                                    <th colSpan="2">Max</th>
                                    <th colSpan="2">Min</th>
                                    <th colSpan="2">Max</th>
                                    <th colSpan="2">Min</th>
                                    <th colSpan="2">Max</th>
                                    <th colSpan="2">Min</th>
                                    <th colSpan="2">Max</th>
                                </tr>
                            </thead>
                            <tbody>{renderFunc()}</tbody>
                            {/* <tfoot>
                            {
                                
                                (!!so[sso] && !!so[sso]?.tempUniqCode) && <tr className="add_param" onClick={addRow}>
                                    <td colSpan={Object.keys(initialData).length + 1}>+Add Parameter</td>
                                </tr>
                            }

                        </tfoot> */}
                        </table>
                    </DndProvider>
                </div>
            </div>
            {ModalOpen && <ModalPortal>{modal}</ModalPortal>}
        </section>
    );
};

export default React.memo(React.forwardRef(QCTable));
